export const createPageTeardown = (): { signal: () => AbortSignal } => {
  let controller = new AbortController();

  window.addEventListener('pagehide', () => controller.abort());
  window.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) controller = new AbortController();
  });

  return { signal: () => controller.signal };
};

const pageTeardown = createPageTeardown();

export const pageTeardownSignal = (): AbortSignal => pageTeardown.signal();
